import { Grid, styled } from '@mui/material';
import React from 'react';

interface Props {
  /** 高蔵寺駅の「南口」かどうか */
  isSouthExit: boolean;
  /** 方面（行き先） */
  destination: string;
  /** バス会社・路線名 */
  busLineName: string;
}

/**
 * 路線名・方面のコンポーネント。
 */
const Destination: React.FC<Props> = (props: Props) => {
  /** 行き先のスタイル */
  const DestinationSpan = styled('span')({
    fontSize: '32px',
    position: 'relative',
    top: '22px',
  });

  /** バス系統のスタイル */
  const BusNameSpan = styled('span')({
    fontSize: '18px',
    position: 'relative',
    top: '16px',
  });

  /** ~行きのスタイル */
  const DirectionSpan = styled('span')({
    fontSize: '16px',
    position: 'relative',
    top: '16px',
  });

  return (
    <Grid container direction="row" alignItems="flex-end">
      {props.isSouthExit && (
        <Grid item xs="auto" marginRight={'20px'}>
          {/** バス会社の表示 */}
          <BusNameSpan>{props.busLineName}</BusNameSpan>
        </Grid>
      )}
      <Grid item xs="auto" marginRight={'20px'}>
        {/** バス行き先表示 */}
        <DestinationSpan>{props.destination}</DestinationSpan>
      </Grid>
      <Grid item xs="auto">
        <DirectionSpan>行き</DirectionSpan>
      </Grid>
    </Grid>
  );
};

export default Destination;
